import { z } from 'zod'

export const ADMINSOLOGENERATIONPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminSoloGenerationPostResponseSchema = z.unknown()
export type AdminSoloGenerationPostResponse = z.infer<typeof adminSoloGenerationPostResponseSchema>
